export default "__VITE_ASSET__C0YEbW0___"